// components/FormatDate.js
const formatDate = (date) => {
  if (!date) return "N/A";

  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) return "N/A";

  return parsedDate.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default formatDate;
